(function () {
    'use strict';
    angular.module('Directives').directive('bbaDetails', bbaJobDetails);

    bbaJobDetails.$inject = [
        'FleetService', 
        'ConfirmationModalFactory', 
        'toastr',
        '$uibModal',
        'TypeStatusConsts'
    ];

    function bbaJobDetails(
        FleetService, 
        ConfirmationModalFactory, 
        toastr,
        $uibModal,
        TypeStatusConsts
    ) {
        return {
            restrict: 'E',
            templateUrl: '/templates/directives/components/job-details/bbaDetails.html',
            scope: {
                ngModel: '=',
                ngDisabled: '=?'
            },
            link: bbaJobDetailsLink
        }

        function bbaJobDetailsLink($scope, $element, $attrs) {
            $scope.jobTypeCost = TypeStatusConsts.jobType;
            $scope.driver = $scope.ngModel.driver;
            $scope.jobFinacials = $scope.ngModel.jobFinacials;
            $scope.deliveryActuals = $scope.ngModel.deliveryActuals;

            $scope.searchDrivers = searchDrivers;
            $scope.TypeStatusConsts = TypeStatusConsts;
         
            $scope.approveDriver = approveDriver;
            $scope.markAsDelivered = markAsDelivered;
            $scope.showJobFinancialDetails = showJobFinancialDetails;

            const approveJobConfirmation = new ConfirmationModalFactory({}, {
                message: 'messages.warning.approveJob.MESSAGE',
                code: 'messages.warning.approveJob.CODE',
            });

            $scope.drivers = [
                {name: 'Jhon Doe'}
            ];

            init();
            function init(){
                if($scope.ngModel.actualJobFinancials) {
                    $scope.ngModel.actualJobFinancials.timeBased = $scope.ngModel.timeBased;
                    $scope.jobCostFormatted = FleetService.Jobs.getJobCostFormattedForFinalAndQuotedPricing(
                        $scope.ngModel.actualJobFinancials, 
                        $scope.ngModel.actualJobFinancials.actualRateUpdated);

                    $scope.driverFee = $scope.ngModel.actualJobFinancials.driverFee;
                }
                else if($scope.ngModel.quotedJobFinancials){
                    $scope.ngModel.quotedJobFinancials.timeBased = $scope.ngModel.timeBased;
                    $scope.jobCostFormatted = FleetService.Jobs.getJobCostFormattedForFinalAndQuotedPricing(
                        $scope.ngModel.quotedJobFinancials, 
                        $scope.ngModel.quotedJobFinancials.actualRateUpdated);

                    $scope.driverFee = $scope.ngModel.quotedJobFinancials.driverFee;
                }
                else {
                    $scope.jobCostFormatted = FleetService.Jobs.getJobCostFormatted($scope.ngModel);
                    $scope.driverFee = $scope.ngModel.jobFinancials.driverFee;
                }
            }

            function approveDriver() {
                approveJobConfirmation.getInstance().result.then(cond => {
                    if (cond){
                        $scope.disabled = true;
                        FleetService.Jobs.updateStatus([$scope.ngModel.id],
                            {toStatus: 'PENDING',remarks: 'Approved'},
                            () => {
                                $scope.ngModel.jobStatus = 'pending';
                                $scope.disabled = false;
                                toastr.success('Successfully driver for this job');
                            },
                            error => {
                                toastr.error('Unable to Approve driver', error.message);
                                $scope.disabled = false;
                            });
                    }
                });
            }

            function searchDrivers(select) {
                if (!select.open)
                    return false;
                $scope.searching = true;
                $scope.drivers = [];
                FleetService.Drivers.getAll(data => {
                    $scope.drivers = data.content;
                    $scope.searching = false;
                }, error => {
                    $scope.searching = true;
                    toastr.error('Unable to search for vehicle types', error.message);
                }, {
                    active: true,
                    fullName: select.search
                });
            }

            function markAsDelivered() {
                $scope.disabled = true;
                FleetService.Jobs.updateStatus([$scope.ngModel.id],
                    {toStatus: 'DELIVERED', remarks: 'Mark as Delivered'},
                    () => {
                        $scope.ngModel.jobStatus = 'delivered';
                        $scope.disabled = false;
                        toastr.success('Job Status updated Succesfully');
                    },
                    error => {
                        toastr.error(error.message || 'Try again.', 'Unable to update Job Status');
                        $scope.disabled = false;
                    });
            }

            function showJobFinancialDetails(){
                const modalInstance = $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    windowClass: 'setting-modal',
                    templateUrl: '/templates/modal/job-financial-details-modal.html', 
                    controller: 'JobFinancialDetailsModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    appendTo: $('body'),
                    resolve: {
                        data: function(){
                            return $scope.ngModel;
                        }
                    }
                });
            }

            function getJobStatusDefaulValue() {
                const currentJobStatus = angular.copy($scope.ngModel.jobStatus);
                $scope.ngModel.jobStatus = {
                    name: TypeStatusConsts.jobStatuses[currentJobStatus],
                    value: currentJobStatus
                }
            }

            function getJobStatuses() {
                $scope.jobStatuses = Object.keys(TypeStatusConsts.jobStatuses)
                    .map(data => {
                        return {
                            name: TypeStatusConsts.jobStatuses[data],
                            value: data
                        }
                    });
            }
        }
    }
})();



// WEBPACK FOOTER //
// ./js/directives/component/job-details/bbaDetails.js